module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 209
// module chunks = 0